import { type NavigationGuardNext, type RouteLocationNormalized } from 'vue-router'
import { toast } from '@previo/design-system'
import { Routes } from '~/router/routes'
import { usePropertyStore } from '~/store/property/property'

const loadSelectedProperty = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const propertyId: number | null = parseInt(to.params.propertyId as string)

  if (!propertyId) {
    const lastPropertyId = usePropertyStore().lastSelected

    if (!lastPropertyId) {
      return next({ name: Routes.GENERAL_SELECT_PROPERTY })
    }

    to.params['propertyId'] = `${lastPropertyId}`

    return next(to)
  }

  usePropertyStore().lastSelected = propertyId

  await usePropertyStore()
    .load(propertyId)
    .catch((e) => {
      toast.warning(e.message)

      return next({ name: Routes.GENERAL_SELECT_PROPERTY })
    })

  return next()
}

export default loadSelectedProperty
